export const PRODUCT_TYPES = {
  PAID_MARKETING: 'paidmarketing',
  BOT_ZAPPING: 'botzapping',
  BUNDLE: 'bundle',
} as const

export const { BUNDLE, ...PRODUCT_TYPES_WITHOUT_BUNDLE } = PRODUCT_TYPES

export type ProductTypes = (typeof PRODUCT_TYPES)[keyof typeof PRODUCT_TYPES]

export type ProductTypesWithoutBundle =
  (typeof PRODUCT_TYPES_WITHOUT_BUNDLE)[keyof typeof PRODUCT_TYPES_WITHOUT_BUNDLE]
